export default "__VITE_ASSET__DwbM63OV__"